import styled from "@emotion/styled";
import * as Switch from "@radix-ui/react-switch";

export const SwitchRoot = styled(Switch.Root)`
    --svy-switch-width: 48px;
    --svy-switch-height: 24px;
    --svy-switch-padding: 2px;
    --svy-switch-border-radius: 50px;
    --svy-switch-background: ${({ theme }) => theme.colors.neutral["100"]};

    --svy-switch-thumb-height: 24px;
    --svy-switch-thumb-width: 24px;
    --svy-switch-thumb-background: ${({ theme }) => theme.colors.secondary["50"]};

    all: unset;
    width: var(--svy-switch-width);
    height: var(--svy-switch-height);
    padding: var(--svy-switch-padding);

    border-radius: var(--svy-switch-border-radius);
    background: var(--svy-switch-background);

    cursor: pointer;

    transition: background ease-in-out 100ms;

    &[data-state="checked"] {
        --svy-switch-background: ${({ theme }) => theme.colors.primary["500"]};
        &:hover:not(:disabled) {
            --svy-switch-background: ${({ theme }) => theme.colors.primary["600"]};
        }
    }

    &:hover:not(:disabled) {
        --svy-switch-background: ${({ theme }) => theme.colors.secondary["200"]};
    }

    &:disabled {
        cursor: unset;
        --svy-switch-thumb-background: ${({ theme }) => theme.colors.secondary["400"]};
    }
`;

export const SwitchThumb = styled(Switch.Thumb)`
    display: block;
    width: var(--svy-switch-thumb-width);
    height: var(--svy-switch-thumb-height);
    background: var(--svy-switch-thumb-background);
    border-radius: 100%;

    transition: transform 100ms;
    transform: translateX(0);

    &[data-state="checked"] {
        transform: translateX(calc(var(--svy-switch-width) - var(--svy-switch-thumb-width)));
    }
`;
